// JS-consumable palette for SVG charts and inline styles — mirrors
// docs/design/web-ui-design-guide.md §2 and the CSS custom properties in
// index.css. LIGHT since the 2026-09-11 redesign: the same names,
// re-derived values — keep the two in step by hand. These are the PAPER
// ground's values (the app's default, `:root`); the Lab's gradient FIELD
// (`html[data-ground="field"]`, hooks/useGround) re-derives the surfaces
// in CSS only — no chart reads a surface colour on the field. Chart fills
// that read `bg` are the page's base tone: a chart's masked area or
// marker halo paints the ground it sits on.

export const COLORS = {
  bg: "#f6f6f3",
  bg2: "#fbfbf9",
  card: "#efefec",
  card2: "#e7e7e3",
  txt: "#14201b",
  txt2: "#34423c",
  txt3: "#46544e",
  green: "#0b8f41",
  greenSoft: "rgba(11,143,65,.12)",
  red: "#d93a2f",
  redSoft: "rgba(217,58,47,.12)",
  accent: "#5b4de6",
  gold: "#b07d0a",
  line: "rgba(20,32,27,.08)",
  line2: "rgba(20,32,27,.14)",
};

// Direction-of-change colors (Robinhood semantics — never decoration).
export const trendColor = (delta) =>
  delta > 0.005 ? COLORS.green : delta < -0.005 ? COLORS.red : COLORS.txt3;

export default COLORS;
